export const SearchableAlphabets = [
  'All',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const SearchableAlphabetsPa = [
  'ਸਭ',
   "ਓ",
   "ਅ",
    "ੲ",
    "ਸ",
    "ਹ",
    "ਕ",
    "ਖ",
    "ਗ",
    "ਘ",
    "ਙ",
    "ਚ",
    "ਛ",
    "ਜ",
    "ਝ",
    "ਞ",
    "ਟ",
    "ਠ",
    "ਡ",
    "ਢ",
    "ਣ",
    "ਤ",
    "ਥ",
    "ਦ",
    "ਧ",
    "ਨ",
    "ਪ",
    "ਫ",
    "ਬ",
    "ਭ",
    "ਮ",
    "ਯ",
    "ਰ",
    "ਲ",
    "ਵ",
    "ੜ",
    "ਸ਼",
    "ਖ਼",
    "ਗ਼",
    "ਜ਼",
    "ਫ਼",
     "ਲ਼"
];

export const InitialBaniSubSection = 2;

export const BaniSubSectionDetailTypes = {
  "en": [
    'Commentary',
    'Literal Translation',
    'Interpretive Transcreation',
    'Poetical Dimension',
    'Calligraphy',
  ],
  "pa": [
    'ਵਿਆਖਿਆ',
    'ਸ਼ਾਬਦਕ ਅਨੁਵਾਦ', //Literal Translation
    'ਭਾਵਾਰਥਕ-ਸਿਰਜਣਾਤਮਕ ਅਨੁਵਾਦ', //Interpretive Transcreation
    'ਕਾਵਿਕ ਪਖ', //Poetic Dimension
    //'ਸ਼ਾਬਦਕ ਅਨੁਵਾਦ',
    'ਕੈਲੀਗ੍ਰਾਫੀ', //Calligraphy
  ]
}

export const OnboardingSteps = {
  "en":[
    "Welcome to the Guru Granth Sahib Project. From here, you'll find featured compositions, recent releases, and upcoming releases.",
    "Looking for a specific verse? Use the 'Search' to find a composition by author, page number, or title.",
    "Open the Guru Granth Sahib tab and show the 'Compositions' button: Browsing Composition Pages",
    "Explore the Guru Granth Sahib Project in Panjabi by clicking here.",
    "Find information on our approach, methodology, historical sources, and more by clicking here.",
    "Do you have feedback? Contact us for assistance or questions by filling out the form here.",
    "Now you're ready to explore the Guru Granth Sahib Project.",
  ],
  "pa":[
    'ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਪ੍ਰੌਜੈਕਟ ਵਿਚ ਆਪ ਜੀ ਦਾ ਸਵਾਗਤ ਹੈ। ਇਥੇ ਆਪ ਜੀ ਪਹਿਲਾਂ ਪ੍ਰਕਾਸ਼ਤ ਹੋ ਚੁੱਕੀਆਂ, ਹਾਲ ਹੀ ਵਿਚ ਪ੍ਰਕਾਸ਼ਤ ਹੋਈਆਂ ਅਤੇ ਆਉਣ ਵਾਲੇ ਸਮੇਂ ਵਿਚ ਪ੍ਰਕਾਸ਼ਤ ਹੋਣ ਵਾਲੀਆਂ ਬਾਣੀਆਂ ਅਤੇ ਸ਼ਬਦ ਪੜ੍ਹ ਸਕਦੇ ਹੋ।',
    "ਕੀ ਆਪ ਜੀ ਕੋਈ ਖਾਸ ਤੁਕ ਜਾਂ ਸ਼ਬਦ ਲੱਭ ਰਹੇ ਹੋ? ਉਸ ਤੁਕ ਜਾਂ ਸ਼ਬਦ ਨੂੰ ਲੱਭਣ ਲਈ ਸੰਬੰਧਤ ਬਾਣੀਕਾਰ, ਪੰਨਾ ਨੰਬਰ ਜਾਂ ਸਿਰਲੇਖ ਲਿਖ ਕੇ 'ਖੋਜ' ਬਟਨ ਉੱਤੇ ਕਲਿੱਕ ਕਰੋ।",
    "ਮੈਨਿਯੂ ਵਿਚ ‘ਬਾਣੀ’ ਉੱਤੇ ਕਲਿੱਕ ਕਰਕੇ ਆਪ ਜੀ ਸਾਰੀਆਂ ਪ੍ਰਕਾਸ਼ਤ ਬਾਣੀਆਂ ਪੜ੍ਹ ਸਕਦੇ ਹੋ।",
    "ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਪ੍ਰੌਜੈਕਟ ਨੂੰ ਅੰਗਰੇਜ਼ੀ ਵਿਚ ਪੜ੍ਹਨ ਲਈ ਇਥੇ ਕਲਿੱਕ ਕਰੋ।",
    "ਸਾਡੀ ਪਹੁੰਚ, ਵਿਧੀ, ਇਤਿਹਾਸਕ ਸਰੋਤਾਂ ਸਮੇਤ ਹੋਰ ਜਾਣਕਾਰੀ ਲਈ ਇਥੇ ਕਲਿੱਕ ਕਰੋ।",
    "ਕੀ ਤੁਹਾਡੇ ਕੋਲ ਕੋਈ ਸੁਝਾਅ ਹੈ? ਇਸ ਵਿਚ ਦਿੱਤਾ ਫਾਰਮ ਭਰ ਕੇ ਕਿਸੇ ਸਵਾਲ ਜਾਂ ਸਹਾਇਤਾ ਲਈ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    "ਹੁਣ ਆਪ ਜੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਪ੍ਰੌਜੈਕਟ ਵਾਚਣ ਲਈ ਪੂਰੀ ਤਰ੍ਹਾਂ ਤਿਆਰ ਹੋ।"
  ]
}
